// src/utils/orgFilters.js

export function normalizeName(str) {
  if (!str) return "";
  return str.toString().trim().toLowerCase().replace(/\s*zone$/i, "").replace(/\s+/g, " ");
}

export function safeEquals(a, b) {
  if (!b) return true;
  return normalizeName(a) === normalizeName(b);
}

// look up a zone's display name from its code, for cross-referencing zone_name fields
export function zoneNameFromCode(code, zonesList) {
  const z = zonesList.find((z) => z.code?.toString() === code?.toString());
  return z?.name || null;
}

export function projectMatchesZone(project, zoneCode, zonesList) {
  if (!zoneCode) return true;
  const zoneName = zoneNameFromCode(zoneCode, zonesList);
  if (!zoneName) return true;
  return normalizeName(project.zone_name) === normalizeName(zoneName);
}